<template>


  <gat-flex :size="getSize()" :relSize="relSize" :hide="hide">
    <gat-field-spacer :size="size">
      <v-textarea v-if="rows" ref="field" v-model="textValue" :label="label" @input="updateValue()" :rows="rows"  :autofocus="autofocus"  auto-grow :disabled="disabled" :readonly="isReadonly" :hint="hint"> </v-textarea>

      <v-checkbox v-else-if="checkbox" ref="field" :label="label" v-model="chkValue" :disabled="disabled" :readonly="isReadonly" :hint="hint"></v-checkbox>

      <v-switch v-else-if="toggle" ref="field" :label="label" v-model="chkValue" :disabled="disabled" :readonly="isReadonly" :hint="hint"></v-switch>

      <gat-date-edit v-else-if="dateEdit" :label="label" v-model="textValue" :autofocus="autofocus" @input="updateValue()" :disabled="disabled" :readonly="isReadonly" :hint="hint" :append-icon="appendIcon"></gat-date-edit>

      <gat-time-edit v-else-if="timeEdit" :label="label" v-model="textValue" :autofocus="autofocus" @input="updateValue()" :disabled="disabled" :readonly="isReadonly" :hint="hint" :append-icon="appendIcon"></gat-time-edit>

      <gat-date-time-edit v-else-if="dateTimeEdit" :label="label" :label2="label2"  v-model="textValue" :autofocus="autofocus" @input="updateValue()" :disabled="disabled" :readonly="isReadonly" :hint="hint" :append-icon="appendIcon"></gat-date-time-edit>

      <v-text-field v-else ref="field" v-model="textValue" :label="label" @input="updateValue()" :autofocus="autofocus" :suffix="suffix" :error-messages="errorMsg" :disabled="disabled"
                    :readonly="isReadonly" :hint="hint" :append-icon="appendIcon" @keyup.enter.native="$emit('onenterkey')"> </v-text-field>
    </gat-field-spacer>
  </gat-flex>

</template>

<script>
  import GatFlex from './GatFlex.vue';
  import GatFieldSpacer from './GatFieldSpacer.vue'
  import GatDateEdit from './GatDateEdit.vue';
  import GatTimeEdit from './GatTimeEdit.vue';
  import GatDateTimeEdit from './GatDateTimeEdit.vue';
  export default {
    name: 'GatEdit',
    components:{GatFlex,GatFieldSpacer,GatDateEdit,GatTimeEdit,GatDateTimeEdit},
    props:['value','label','label2','size','hide','rows','relSize','checkbox','suffix','dataType','dateEdit','timeEdit','dateTimeEdit','autofocus','required','toggle','disabled','readonly','hint','decimals','appendIcon'],
    inject:['getGroupReadonly'],
    data:function(){
      return{
        textValue : null,
        chkValue : null,
        errorMsg:[],
        internalDataType : null,
      }
    },
    watch:{
      dataType:function(newValue){
        this.internalDataType = newValue;
      },

      chkValue(){
       this.updateValue();
      },

      value:function(newValue){
        if(!this.internalDataType){
          this.internalDataType = typeof(newValue);
        }
        if(this.checkbox || this.toggle){
          this.chkValue = newValue;
        } else{
          this.textValue = newValue;
        }
        if(this.decimals){
          this.textValue = this.roundSafe(newValue,this.decimals);
        }

      }
    },

    created(){
      this.internalDataType = this.dataType;
    },

  computed:{

    isReadonly(){
      if(typeof this.readonly != 'undefined'){
        return this.readonly
      } else{
        return this.getGroupReadonly();
      }
    },


    dataTypevalue(){
      return 'dataype '+ this.internalDataType;
    }
  },

    methods: {

      validateValue(){
        let result = true;
        //tall
        if(this.internalDataType===typeof 0){
            if(isNaN(this.textValue)){
              this.errorMsg.push('not a valid number');
              result = false;
            } else{
              this.errorMsg = [];
            }
          }

        if(this.required && this.textValue==''){
           this.errorMsg.push('Required');
            result = false;
        }

        return result;
      },

      roundSafe(value,decimals) {
        return +(Math.round(value + "e+" + decimals)  + "e-" + decimals);
      },

      getSize(){
        if(this.size){
          return this.size
        } else if(this.dateEdit){
          return "xs4 sm3 md2 xl1"
        }else if(this.timeEdit){
          return "xs3 sm2 md1"
        }else if(this.dateTimeEdit){
          return "xs6 sm3 md2"
        }
      },

      getValue(){
        let result = this.textValue;
        if(this.internalDataType===typeof 0){
          if(this.textValue==''){
            result = null;
          } else{
            result = parseFloat(this.textValue);
            if(Number.isNaN(result)){
              result = null;
            }else{
              if(this.decimals){
                result = this.roundSafe(result,this.decimals);
              }
            }
          }

        }

        if(this.checkbox || this.toggle){
          result = this.chkValue;
        }

        return result;
      },

      updateValue() {
        this.validateValue();
        let value = this.getValue();
        this.$emit('input',value );
      }
    },

    }
</script>

<style scoped>

</style>
